import { CANVAS_UPDATE_MESSAGE_UUID } from 'client/actions/constants';

/**
 * Reducer for the canvas chat slice.
 * Tracks the active message UUID used to coordinate streaming responses.
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export function canvasReducer(state = {}, action = {}) {
  switch (action.type) {
    case CANVAS_UPDATE_MESSAGE_UUID:
      return {
        ...state,
        messageUUID: action.messageUUID,
      };
    default:
      return state;
  }
}
